import {
  BalanceType,
  GetPatientsBalanceResponse_PatientBalance,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { Filters } from 'react-table';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, RadioField, Text, useControlledField } from '@frontend/design-system';

type CollectionFilterMenuProps = {
  handleFilter: ({ key, val }: { key: string; val: string }) => void;
  selectedFilters: Filters<GetPatientsBalanceResponse_PatientBalance>;
};
export const CollectionFilterMenu = ({ handleFilter, selectedFilters }: CollectionFilterMenuProps) => {
  const { t } = useTranslation('payments');
  const radioFieldProps = useControlledField({
    type: 'radio',
    onChange: (val) => handleFilter({ val: val, key: 'balanceType' }),
    value: selectedFilters.find((filter) => filter.id === 'balanceType')?.value || '',
  });

  const handleClear = () => handleFilter({ val: '', key: 'balanceType' });

  return (
    <>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid ${theme.colors.neutral20}`,
          padding: theme.spacing(1, 4),
        }}
      >
        <Text size='large' weight='bold'>
          {t('Filter')}
        </Text>
        <Button variant='tertiary' size='large' onClick={handleClear}>
          {t('Clear')}
        </Button>
      </div>
      <div css={{ padding: theme.spacing(4) }}>
        <Text size='large' weight='bold'>
          {t('Balance Type')}
        </Text>
        <div css={{ paddingTop: theme.spacing(2) }}>
          <RadioField {...radioFieldProps} name='balance-type'>
            <RadioField.Radio value={BalanceType.BALANCE_TYPE_NEW}>{t('New Balances')}</RadioField.Radio>
            <RadioField.Radio value={BalanceType.BALANCE_TYPE_UPDATE}>{t('Changed Balances')}</RadioField.Radio>
            <RadioField.Radio value={BalanceType.BALANCE_TYPE_EXISTS}>{t('Existing Balances')}</RadioField.Radio>
          </RadioField>
        </div>
      </div>
    </>
  );
};
